// Create Settings Component
import React from "react";
import Sale from "./sale";
import AIBuilderAdapter from "./ai-builder";

function Settings() {
    return (
        <div className="font-Inter flex-1 h-screen overflow-y-scroll bg-white items-start p-7">
            <h1 className="text-[32px]">
                Settings
            </h1>
            <Sale />
            <hr className="my-8 border-gray-200" />
            <AIBuilderAdapter />
        </div>
    )
}

export default Settings